export default "__VITE_ASSET__DliRz_sh__"